module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABOUlEQVRYhb2XUY7DIAxETdV7hZth38w5mfdjS5YSQjM23ZGsEik1zIsxSTIzQiWSjj+VYglO0MrMoGD+u1RV+02B5WjDPXm/CGZ2LeQRwkdE25aPsYjgzzPifkQBJREm0FP4CoGZ+yiFJQRCFFa4j1CACey7Ukp0xL5rjALqnugcEQrLaqAKpoA++979KAVCYTkBIpACWvm9+4sUtynABJjn1zAFdN9XZzVUNdQXYAK9s5nTWxQ8XY+ZXs7i3dG1C3LWt9+ZPlJA3be74e69MwruPmDAu8+Ugsd9uxNmu+AOBWcN5OHYRQF1P+qGkVpwEVDV4dhD4elZwLblpgjPSe9KROwrp+GV2renqkcplkT+Z/KcM3F3eiV7sRRJdnWyrVI/+dsCqlyfV06VUtKpBkopsc9tYHIioh8y2r2jCTCoDgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/walleris/images/WARNING.png
// module id = 108
// module chunks = 0